import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { HttpClientService } from '../../core/services/http/http-client.service';
import { ISavedQuote } from '../models/saved-quote.interface';
import { Package } from '../../ship/models/package.model';
import { ApiEndpointService } from '../../core/services/api-endpoint.service';

@Injectable()
export class SavedQuotesService {
  constructor(private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {
  }

  public getSavedQuotes(pageIndex: number, pageSize: number): Observable<ISavedQuote[]> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getSavedQuotes'))
      .query({
        page: pageIndex,
        per_page: pageSize,
      })
      .toString();

    return this.httpClientService.get<ISavedQuote[]>(endpoint);
  }

  public getSavedQuote(quoteId: string): Observable<Package> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('getQuote'))
      .param('quoteId', quoteId)
      .toString();

    return this.httpClientService.get<Package>(endpoint);
  }

  public deleteQuote(quoteId: string): Observable<any> {
    const endpoint = SafeUrlAssembler()
      .template(this.apiEndpointService.getEndpoint('deleteQuote'))
      .param('quoteId', quoteId)
      .toString();

    return this.httpClientService.delete<any>(endpoint);
  }
}
